import axios from "../api/axios";
import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";

export default function DownloadDialog(props) {
  const [selectedFile, setSelectedFile] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [fileExistence, setFileExistence] = useState({
    resultFile: false,
    logFile: false,
    errorFile: false,
  });
  const handleDownload = () => {
    if (selectedFile) {
      props.onDownload(selectedFile);
    } else {
      setErrorMessage("Please select a file to download.");
    }
  };
  const fetchExistence = async () => {
    if (!props.jobId) {
      setFileExistence({
        resultFile: false,
        logFile: false,
        errorFile: false,
      });
      return;
    }
    axios
      .post("/api/job-file-existance", {
        jobid: props.jobId,
      })
      .then((res) => {
        setFileExistence(res.data);
      })
      .catch((err) => {
        setErrorMessage("Failed to fetch File data.");
      });
  };

  useEffect(() => {
    fetchExistence();
  }, []);

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        if (errorMessage) {
          setErrorMessage("");
        }
      }, 10000); // 10 seconds

      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  return (
    <Modal
      show={props.show}
      onHide={props.onClose}
      centered
      backdrop="static" // Prevent closing on overlay click
      keyboard={false}
      contentClassName="p-4 pb-5 p-sm-5"
    >
      <Modal.Header className="flex-column p-0 border-0">
        <p className="sub-step-bold mb-2">Downloads</p>
        <p className="text-center m-0">Select files you wish to download.</p>
      </Modal.Header>
      <Modal.Body className="mt-4 mb-4 p-0">
        <Form>
          {errorMessage && (
            <div id="error-message" className="error-message">
              {errorMessage}
            </div>
          )}
          <Form.Check
            type="radio"
            label="Log File"
            name="fileOptions"
            value="logfile"
            onChange={(e) => setSelectedFile(e.target.value)}
            disabled={!fileExistence.logFile}
            className="mb-3"
          />
          <Form.Check
            type="radio"
            label="Error File"
            name="fileOptions"
            value="errfile"
            onChange={(e) => setSelectedFile(e.target.value)}
            disabled={!fileExistence.errorFile}
            className="mb-3"
          />
          <Form.Check
            type="radio"
            label="Result File"
            name="fileOptions"
            value="resultfile"
            onChange={(e) => setSelectedFile(e.target.value)}
            disabled={!fileExistence.resultFile}
            className="mb-0"
          />
        </Form>
      </Modal.Body>
      <Modal.Footer className="flex-column border-0 p-0">
        <div className="w-100 m-0">
          <button
            onClick={handleDownload}
            className="w-100 m-0 learnmore-btn"
            disabled={
              !fileExistence.logFile &&
              !fileExistence.errorFile &&
              !fileExistence.resultFile
            }
          >
            Download
          </button>
        </div>
        <div style={{ margin: "24px 0 0" }}>
          <a href="#" className="review-text" onClick={props.onClose}>
            Cancel
          </a>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
